import React, { createContext, useState, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { SUBMISSION_MCCAIN_REVIEW_STEP } from 'screens/Integrations/helpers/constants';

export const MccainContext = createContext();

export const MCCAIN_SUCCESS_STEP = SUBMISSION_MCCAIN_REVIEW_STEP + 1;

const Provider = ({ children }) => {
  const [step, setStep] = useState(1);
  const [comingFromStep, setComingFromStep] = useState(1);
  const [canGoNext, setCanGoNext] = useState(false);
  const [openSubmissionModal, setOpenSubmissionModal] = useState(false);

  const blockStepForward = () => setCanGoNext(false);
  const releaseStepForward = () => setCanGoNext(true);

  const goBack = () => {
    setComingFromStep(step);
    setStep(s => Math.max(0, s - 1));
  };

  const goForward = () => {
    setComingFromStep(step);
    setStep(s => s + 1);
  };

  const setModalSubmissionState = bool => setOpenSubmissionModal(bool);

  const finishSubmission = useCallback(() => {
    setComingFromStep(step);
    setStep(MCCAIN_SUCCESS_STEP);
    setOpenSubmissionModal(false);
  }, [step]);

  const store = useMemo(
    () => ({
      state: { step, comingFromStep, canGoNext, openSubmissionModal },
      gotoStep: setStep,
      goBack,
      goForward,
      blockStepForward,
      releaseStepForward,
      setModalSubmissionState,
      finishSubmission
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [step, comingFromStep, canGoNext, openSubmissionModal, finishSubmission]
  );

  return (
    <MccainContext.Provider value={store}>{children}</MccainContext.Provider>
  );
};

Provider.defaultProps = {
  children: null
};

Provider.propTypes = {
  children: PropTypes.node
};

export default Provider;
